"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const Copy_1 = __importDefault(require("src/components/svg/Copy"));
const Success_1 = __importDefault(require("src/components/svg/Success"));
const CopyToClipboard = ({ value, className }) => {
    const [copySuccess, setCopySuccess] = (0, react_1.useState)(false);
    const textAreaRef = (0, react_1.useRef)(null);
    function copyToClipboard(e) {
        var _a;
        (_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(value);
        e.target.focus();
        setCopySuccess(true);
        return setTimeout(() => {
            setCopySuccess(false);
        }, 1500);
    }
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `copy-to-clipboard ${className}` }, { children: [(0, jsx_runtime_1.jsx)("code", Object.assign({ className: "copy-to-clipboard-code", ref: textAreaRef }, { children: value })), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, Object.assign({ onClick: copyToClipboard, variant: "primary", className: "btn_onlyicon btn-outline" }, { children: !copySuccess ? (0, jsx_runtime_1.jsx)(Copy_1.default, {}) : (0, jsx_runtime_1.jsx)(Success_1.default, {}) }))] })) }));
};
exports.default = CopyToClipboard;
